import { mode } from 'webconfig'
import axios from 'axios'

const baseUrlMap = {
    dev: 'https://videomonsterweb-dev.azurewebsites.net',
    lang: 'https://videomonsterweb-lang.azurewebsites.net',
    local: 'http://localhost:2008',
    stage: {
        KR: 'https://videomonster.com',
        // US: 'https://videomonsterusweb2.azurewebsites.net',
        // US_WEST: 'https://videomonsterwestusweb2.azurewebsites.net',
        // UK_SOUTH: 'https://videomonsteruksouthweb.azurewebsites.net'
    }
}

// let region = 'KR'
let baseUrl = null

if (mode === 'stage') baseUrl = baseUrlMap[mode]['KR']
else baseUrl = baseUrlMap[mode]

export const SetConfig = (value = 'KR') => {
    /*
        US / US_WEST / UK_SOUTH Region WAS 삭제
    */
    // if (mode !== 'stage' || region === value || !baseUrlMap[mode][value]) return

    // region = value
    // baseUrl = baseUrlMap[mode][value]

    if (mode !== 'stage' || !baseUrlMap[mode]['KR']) return
    baseUrl = baseUrlMap[mode]['KR']
}

export const GetBaseUrl = () => {
    return baseUrl
}

export const GetDefaultUrl = () => {
    if (mode === 'stage') return baseUrlMap[mode]['KR']
    else return baseUrlMap[mode]
}

export const GetOriginalBaseUrl = (value = 'KR') => {
    // 이우섭 20220509 추가
    // 모든 API 서버의 region 값을 KR로 통일하고 KR storage를 직접 연결했습니다.
    // video.region값은 무조건 KR이며, 모든 리전의 API 서버를 통해 동일하게 접근 가능합니다.
    // 따라서 GetBaseUrl로 임시로 처리합니다.
    return GetBaseUrl()

    // value => video.region

    // Azure Render Server VM과 Storage Account는 KR리전, US리전 두 곳에만 존재하며, DB의 video.region에는 두 개의 값만 지정됩니다.
    // (videomonster-server의 process.env.REGION 값 => video.region으로 찍힘.)
    // (미국동부, 미국서부, 영국 서버 => process.env.REGION: US)
    // (한국 서버 => process.env.REGION: KR)

    // 단, 서양에서는 가까운 API 리전을 통해 리소스를 업로드/다운로드 하도록 로직을 작성했습니다.
    // if (mode === 'stage') {
    //     console.log(value)
    //     switch (value) {
    //         case 'US':
    //             {
    //                 let targetRegion = 'US'
    //                 switch (region) {
    //                     // US_WEST, UK_SOUTH는 process.env.REGION이 US이므로 US Storage에 접근이 가능합니다.
    //                     // API 서버를 가까운 곳으로 설정하여 가속합니다.
    //                     case 'US_WEST':
    //                     case 'UK_SOUTH':
    //                         targetRegion = region
    //                         break

    //                     // 다른 region에서는 별다른 처리를 하지 않습니다.
    //                     case 'KR':
    //                     case 'US':
    //                     default:
    //                         break
    //                 }


    //                 console.log('original url : ', baseUrlMap[mode][targetRegion])
    //                 return baseUrlMap[mode][targetRegion]
    //             }

    //         // KR에서 생성된 Video는 무조건 KR API 서버로만 가져옵니다.
    //         case 'KR':
    //         default:
    //             console.log('original url : ', baseUrlMap[mode]['KR'])
    //             return baseUrlMap[mode]['KR']
    //     }
    // }

    // return baseUrl
}

// NOTE :: US Region을 삭제하여 사용하지 않게됨
export const GetRegionByCountryCode = async countryCode => {
    switch (countryCode) {
        // [ASIA]
        case "AE":
        case "AF":
        case "AM":
        case "AZ":
        case "BD":
        case "BH":
        case "BN":
        case "BT":
        case "CN":
        case "CY":
        case "GE":
        case "HK":
        case "ID":
        case "IL":
        case "IN":
        case "IQ":
        case "IR":
        case "JO":
        case "JP":
        case "KG":
        case "KH":
        case "KP":
        case "KR":
        case "KW":
        case "KZ":
        case "LA":
        case "LB":
        case "LK":
        case "MM":
        case "MN":
        case "MO":
        case "MV":
        case "MY":
        case "NP":
        case "OM":
        case "PH":
        case "PK":
        case "PS":
        case "QA":
        case "SA":
        case "SG":
        case "SY":
        case "TH":
        case "TJ":
        case "TL":
        case "TM":
        case "TR":
        case "UZ":
        case "VN":
        case "YE":
            return "KR"

        // [EUROPE]
        case "AD":
        case "AL":
        case "AT":
        case "AX":
        case "BA":
        case "BE":
        case "BG":
        case "BY":
        case "CH":
        case "CZ":
        case "DE":
        case "DK":
        case "EE":
        case "ES":
        case "FI":
        case "FO":
        case "FR":
        case "GB":
        case "GG":
        case "GI":
        case "GR":
        case "HR":
        case "HU":
        case "IE":
        case "IM":
        case "IS":
        case "IT":
        case "JE":
        case "LI":
        case "LT":
        case "LU":
        case "LV":
        case "MC":
        case "MD":
        case "ME":
        case "MK":
        case "MT":
        case "NL":
        case "NO":
        case "PL":
        case "PT":
        case "RO":
        case "RS":
        case "RU":
        case "SE":
        case "SI":
        case "SJ":
        case "SK":
        case "SM":
        case "UA":
        case "VA":
            return "UK_SOUTH"

        // [AFRICA]
        case "AO":
        case "BF":
        case "BI":
        case "BJ":
        case "BW":
        case "CD":
        case "CF":
        case "CG":
        case "CI":
        case "CM":
        case "CV":
        case "DJ":
        case "DZ":
        case "EG":
        case "EH":
        case "ER":
        case "ET":
        case "GA":
        case "GH":
        case "GM":
        case "GN":
        case "GQ":
        case "GW":
        case "IO":
        case "KE":
        case "KM":
        case "LR":
        case "LS":
        case "LY":
        case "MA":
        case "MG":
        case "ML":
        case "MR":
        case "MU":
        case "MW":
        case "MZ":
        case "NA":
        case "NE":
        case "NG":
        case "RE":
        case "RW":
        case "SC":
        case "SD":
        case "SH":
        case "SL":
        case "SN":
        case "SO":
        case "SS":
        case "ST":
        case "SZ":
        case "TD":
        case "TF":
        case "TG":
        case "TN":
        case "TZ":
        case "UG":
        case "YT":
        case "ZA":
        case "ZM":
        case "ZW":
            return "UK_SOUTH"

        // [OCEANIA]
        case "AS":
        case "AU":
        case "CC":
        case "CK":
        case "CX":
        case "FJ":
        case "FM":
        case "GU":
        case "HM":
        case "KI":
        case "MH":
        case "MP":
        case "NC":
        case "NF":
        case "NR":
        case "NU":
        case "NZ":
        case "PF":
        case "PG":
        case "PN":
        case "PW":
        case "SB":
        case "TK":
        case "TO":
        case "TV":
        case "UM":
        case "VU":
        case "WF":
        case "WS":
            return "KR"

        // [NORTH AMERICA]
        case "AG":
        case "AI":
        case "AW":
        case "BB":
        case "BL":
        case "BM":
        case "BQ":
        case "BS":
        case "BZ":
        case "CA":
        case "CR":
        case "CU":
        case "CW":
        case "DM":
        case "DO":
        case "GD":
        case "GL":
        case "GP":
        case "GT":
        case "HN":
        case "HT":
        case "JM":
        case "KN":
        case "KY":
        case "LC":
        case "MF":
        case "MQ":
        case "MS":
        case "MX":
        case "NI":
        case "PA":
        case "PM":
        case "PR":
        case "SV":
        case "SX":
        case "TC":
        case "TT":
        case "US":
        case "VC":
        case "VG":
        case "VI":
            return "US"

        // [SOUTH AMERICA]
        case "AR":
        case "BO":
        case "BR":
        case "BV":
        case "CL":
        case "CO":
        case "EC":
        case "FK":
        case "GF":
        case "GS":
        case "GY":
        case "PE":
        case "PY":
        case "SR":
        case "UY":
        case "VE":
            return "US"

        case "AQ":
        default:
            return "KR"
    }
}

// NOTE :: US Region을 삭제하여 사용하지 않게됨
export const TraceUSRegion = async () => {
    if (mode === 'stage') {
        const CheckHeadRequestResponseTime = async url => {
            const now = Date.now()
            await axios.head(url)
            return Date.now() - now
        }
    
        const [
            rst_US,
            rst_US_WEST,
        ] = await Promise.all([
            CheckHeadRequestResponseTime(baseUrlMap.stage['US']),
            CheckHeadRequestResponseTime(baseUrlMap.stage['US_WEST'])
        ])

        return rst_US <= rst_US_WEST ? 'US' : 'US_WEST'
    }
    else return 'US'
}